"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _slice = require("@lce/slice");

var _i18n = require("@lce/i18n");

var _types = require("@lce/types");

var _useCart = _interopRequireDefault(require("../../../useCart/useCart"));

var Styled = _interopRequireWildcard(require("./Subtotal.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var Subtotal = function Subtotal() {
  var _a = (0, _i18n.useTranslation)(),
      locale = _a.i18n.language,
      t = _a.t;

  var subtotal = (0, _useCart["default"])().subtotal;
  var isMX = locale === _types.Const.locales.mx.es;
  var currencyFormatter = (0, _i18n.getCurrencyFormatter)(locale, t);
  return React.createElement(_slice.Box, {
    mb: 4
  }, React.createElement(_slice.Flex, {
    width: "1"
  }, React.createElement(_slice.Box, {
    flex: "1"
  }, React.createElement(Styled.Subtotal, {
    as: "h2",
    "data-testid": "mini-cart__subtotal-label"
  }, isMX ? t('Common.Total') : t('Common.Subtotal')), React.createElement(Styled.Disclaimer, {
    "data-testid": "mini-cart__disclaimer-label"
  }, t('Header.Cart.Disclaimer Label'))), React.createElement(_slice.Box, null, React.createElement(Styled.Subtotal, {
    "data-testid": "mini-cart__subtotal-price"
  }, currencyFormatter.format(subtotal)))));
};

var _default = Subtotal;
exports["default"] = _default;